import Rest from '@/services/Rest'

export default class OidService extends Rest {
  /**
   * @type {String}
   */
  static resource = '/oids'

}
